import { emptyFragment, Typography } from '@execonline-inc/execonline-ui';
import { observer } from 'mobx-react';
import { T } from '../../../../Translations';
import { shareStore } from './Stores/ShareStore';

function LicenseBanner() {
  return shareStore.learningCollection
    .andThen((lc) =>
      lc.license.map((license) => (
        <div
          className="bg-primary text-primary-foreground px-4 py-3 flex items-center justify-center w-full"
          data-intercom-target="share-vip-license-banner"
        >
          <Typography variant="bodyLarge" as="span" color="inherit" className="text-center">
            <T
              kind="<licenseName/> <license/> required for full collection access; participants can only view programs included in their license."
              licenseName={<span className="font-bold">{license.licenseTypeName}</span>}
              license={<span className="font-bold">license</span>}
            />
          </Typography>
        </div>
      )),
    )
    .getOrElse(emptyFragment);
}

export default observer(LicenseBanner);
